import React from 'react';
import { SnackbarKey, SnackbarProvider } from 'notistack';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import { snackbarIconVariant } from './FsSnackbarProvider.utils';
import { NotificationIconButton } from './FsSnackbarProvider.style-elements';
import { useStyles } from './FsSnackbarProvider.style';

const FsSnackbarProvider: React.FC = ({ children }) => {
  const notistackRef = React.createRef<SnackbarProvider>();
  const snackbarClasses = useStyles();
  const onClickDismiss = (key: SnackbarKey) => () => {
    notistackRef?.current?.closeSnackbar(key);
  };
  return (
    <SnackbarProvider
      ref={notistackRef}
      maxSnack={4}
      preventDuplicate
      classes={snackbarClasses}
      iconVariant={snackbarIconVariant}
      action={(key: SnackbarKey) => (
        <NotificationIconButton onClick={onClickDismiss(key)} size="small">
          <CloseRoundedIcon />
        </NotificationIconButton>
      )}
    >
      {children}
    </SnackbarProvider>
  );
};

export default FsSnackbarProvider;
